module.exports = __webpack_public_path__ + "school/img/shangsheng.267ce9fe.png";